export default __webpack_public_path__ + "static/media/polar2dnut.ac6402d8.jpg";